<template>
  <div class="echart" id="myEcharts"/>
</template>
<script>
import echarts from 'echarts'

export default {
  data(){
    return {
      charts:null,
      setOption:{},
    }
  },
  props:{
    xdata: {
      default: [],
    },
    ydata:{
      default: [],
    }
  },
  watch: {
    //观察option的变化
    ydata: {
      handler(newVal, oldVal) {
        console.log(newVal)
        if (this.charts) {

          if (newVal) {

            this.init()
          } else {
            this.init()
          }
        } else {
          this.init();
        }
      },
      deep: true //对象内部属性的监听，关键。
    }
  },
  methods:{
    init(){
      this.charts = echarts.init(document.getElementById('myEcharts'));
      window.addEventListener('resize', this.charts.resize, false);
      console.log(this.ydata)
      this.setOption = {
        grid:{
          top:"100px",
          left:"70px",
          right:"30px",
          bottom:"30px"
        },
        legend:{//折现图各颜色，所代表的信息
          // padding:5 ,//图例内边距，单位px，默认上下左右内边距为5
          // itemGap:10,//legend各个item之间的间隔，横向布局是为水平间隔，纵向布局为纵向间隔
          data:['月度完成','公路车辆调配','水路车辆调配'],
          orient:"horizontal",//布局方式，，默认为水平布局，可选为：‘horizontal’水平|‘vertical’垂直
        },
        tooltip: {
          trigger: 'axis',
          // formatter:'{c}m³'
        },
        xAxis: {
          type: 'category',
          data: this.xdata,
          axisTick:{
            show:false
          },
          axisLabel:{
            interval:0,
            color:'#555'
          },
          axisLine:{
            lineStyle:{
              color:'#797979'
            }
          },
        },
        yAxis: {
          type: 'value',
          axisTick:{
            show:false
          },
          axisLine:{
            show:false,
          },
          splitLine:{
            lineStyle: {
              color:['#AAAAAA'],
            }
          },
          axisLabel:{
            // formatter:'{value}m³'
          },
        },
        series: [{
          name:'月度完成',
          data: this.ydata.data1,
          smooth: true,
          type: 'line',
          symbol:'circle',
          symbolSize:10,
          lineStyle: {
            color: '#02A7F0',
            width: 1,
          },
          itemStyle: {
            borderWidth: 1,
            borderColor: '#fff',
            color: '#009DD9',
            shadowColor:'#007979',
            shadowBlur:10,
          }
        },{
          name:'公路车辆调配',
          data: this.ydata.data2,
          smooth: true,
          type: 'line',
          symbol:'circle',
          symbolSize:10,
          lineStyle: {
            color: '#02A7F0',
            width: 1,
          },
          itemStyle: {
            borderWidth: 1,
            borderColor: '#fff',
            color: '#0cd265',
            shadowColor:'#007979',
            shadowBlur:10,
          }
        },
          {
            name:'水路车辆调配',
            data: this.ydata.data3,
            smooth: true,
            type: 'line',
            symbol:'circle',
            symbolSize:10,
            lineStyle: {
              color: '#ff8a32',
              width: 1,
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: '#ff8a32',
              color: '#ff8a32',
              shadowColor:'#ff8a32',
              shadowBlur:10,
            }
          }
        ]
      }
      this.charts.setOption(this.setOption)
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.charts.resize, false);
  },
}
</script>
<style lang="scss" scoped>
.echart{
  width: 100%;
  height: 100%;
}
</style>
